import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { FileUpload } from "primeng/fileupload";
import { FILE_UPLOAD } from "src/app/common/constant/fileupload.constant";
//import { GLOBAL_CONSTANT } from "src/app/common/constant/global.constant";
import { SessionService } from "src/app/common/services/session.service";
import { locationBinderInterface } from "src/app/shared/component/location-binder/location-binder.interface";
import { SharedService } from "src/app/shared/service/api/shared.service";
import { UtilityService } from "src/app/shared/utility.service";
import { environment } from "src/environments/environment";
import { GenericService } from "../service/API/generic.service";
import * as _ from "underscore";
import { MessageService } from "primeng/api";
import { GLOBAL_CONSTANT } from "../../../app/common/constant/global.constant"

@Component({
  selector: "app-generic-dynamic-entry",
  templateUrl: "./generic-for-dynamic-entry.component.html",
  styleUrls: ["./generic-for-dynamic-entry.component.scss"],
  providers: [MessageService],
})
export class GenericForDynamicEntryComponent implements OnInit {
  @Output() dynamicContinue = new EventEmitter();
  isEditable: boolean = false;
  @Input() editable;
  isReadOnly: boolean = false;
  existVisitor: boolean = false;
  castData: any;
  subCastData: any;

  _data: any;
  genderTypes = GLOBAL_CONSTANT.GENDER_TYPES;
  voterTypes = GLOBAL_CONSTANT.VOTER_TYPES;
  rationCardData = GLOBAL_CONSTANT.RATIONCARD_DATA;
  cityType = GLOBAL_CONSTANT.CITY_TYPES;
  editableMode: boolean = false;
  photoFlag: boolean = false;
  photo: any;
  profilePhoto: any;
  picture: any;
  profileError: boolean = false;
  uploadedFiles = [];
  _entityName: string = "profileImage";
  @ViewChild("imageUpload", { static: false }) imageUpload: FileUpload;
  voterData: any;
  officeId: any;
  netaFlag: boolean = false;
  userRole: any;
  yearRange: string;
  searchResultListConfig: any;
  totalRecords: any;
  selectedRationCard: string;
  gaonData: Array<any>;
  prabhagAreaData: Array<any>;
  locationBinderObj: locationBinderInterface;
  message: string;
  visitorId: any;
  apiBaseUrl = environment.API_BASE;
  previewImg: string = "assets/icons/userpro.png";
  uploadAPI = FILE_UPLOAD.Profile_image;
  filetype = FILE_UPLOAD.File_type;

  editableNumber: any;
  hideInfoForm: boolean;
  @Input() showErrorMsg;
  @Input() showMandatoryMark;
  @Input() showMobileError;

  @Input()
  get selectedVisitor(): any {
    return this._data;
  }

  set selectedVisitor(value) {
    if (value && this.editable) {
      this._data = {
        extraFields: {},
        addressFields: {},
      };
      this._data = value;
    } else {
      this._data = {
        extraFields: {},
        addressFields: {},
      };
    }
    if (this.editable) {
      this.locationBinderObj = {
        assembly: value.assembly,
        gat_number: value.gat_number,
        gan_number: value.gan_number,
        gaon: value.gaon,
        prabhag: value.prabhag,
        cityType: value.cityType,
        prabhagArea: value.prabhagArea,
      };
    }
    if (this._data.dob) {
      this._data.dob = this._data.dob ? new Date(this._data.dob) : null;
    }
    if (this._data.id) {
      this.editableMode = true;
    }
    if (this._data.rationCard) {
      this.selectedRationCard = _.find(this.rationCardData, (a) => {
        return a.value === this._data.rationCard;
      });
    }
    if (this._data.cast) {
      this.getCast();
    }
  }
  constructor(
    private service: SharedService,
    private sessionService: SessionService,
    private utilityService: UtilityService,
    private genericService: GenericService,
    private spinner: NgxSpinnerService,
    private toast: MessageService
  ) {
    this.yearRange = this.utilityService.CalYearRange();
    this._data = {
      extraFields: {},
      addressFields: {},
    };
    this.locationBinderObj = {};
  }

  calculateAge(dob) {
    if (this._data.dob != null) {
      dob = new Date(dob.model);
      if (dob != "Invalid Date") {
        this._data.age = moment().diff(dob, "years");
      }
      this._data.dob = new Date(
        Date.UTC(dob.getFullYear(), dob.getMonth(), dob.getDate())
      );
    } else {
      this._data.age = 0;
    }
  }

  //Gaon List
  getGaonList(id) {
    this.service.getGaonDataWithAssembly(id).subscribe((res: any) => {
      this.gaonData = res[0];
    });
  }

  // prabhag area
  getPrabhagAreaList(id) {
    this.service.getPrabhagAreaData(id).subscribe((res: any) => {
      this.prabhagAreaData = res;
    });
  }

  // Check Existing Number
  checkExistingNo(obj) {
    let data = { phone: obj.target.value };
    if (data.phone !== this.editableNumber) {
      this.service.checkExistingNumber(data).subscribe(
        (res: any) => {},
        (err: any) => {
          this.message = err.error.message;
        }
      );
    } else {
    }
  }

  getDataFromVisitorList() {
    this.genericService.messageSource.subscribe((response: any) => {
      if (response.data !== undefined) {
        this._data = response.data;
        this.visitorId = response.data.id;
        this.existVisitor = false;
      }
      if (this._data.ProfileImage) {
        if (
          this._data.ProfileImage.length != 0 &&
          this._data.ProfileImage != "[]"
        ) {
          this.photo = JSON.parse(this._data.ProfileImage);
          this.profilePhoto = this.photo[0].filename;

          if (this.profilePhoto.indexOf(this._entityName) > -1) {
            this.picture =
              this.apiBaseUrl +
              "/file-uploader/downloadS3?path=" +
              this.profilePhoto;
          } else {
            this.picture =
              this.apiBaseUrl +
              "/file-uploader/file2?path=" +
              this._entityName +
              `/${this.profilePhoto}`;
          }
        }
      }

      if (this.profilePhoto != null || this.profilePhoto != undefined) {
        this.photoFlag = true;
      }
      if (this._data.rationCard) {
        this.selectedRationCard = _.find(this.rationCardData, (a) => {
          return a.value === this._data.rationCard;
        });
      }
      if (this._data.cast) {
        this.getCast();
      }
      if (this._data.dob) {
        this._data.dob = this._data.dob ? new Date(this._data.dob) : null;
      }
      if (this._data.addressFields === null) {
        this._data.addressFields = {
          address: "",
        };
      }
    });
  }

  getCast() {
    this.service.getCast().subscribe((res: any) => {
      this.castData = res;
      if (this._data.cast != undefined) {
        this.castData.filter((cast) => {
          cast.id === this._data.cast["id"] ? (this._data.cast = cast) : "";
          this.getsubcastWithCast(this._data.cast["id"]);
        });
      }
    });
  }

  getsubcastWithCast(id) {
    this.castData.forEach((element) => {
      if (element.id == id) {
        this.subCastData = element.subcast;
        this.subCastData.filter((ctype) => {
          ctype.id === this._data.subcast ? (this._data.subcast = ctype) : "";
        });
      }
    });
  }

  onChangeCast() {
    let selectedCastId = this._data.cast["id"];
    this.getsubcastWithCast(selectedCastId);
  }

  onChangeRationCard(selectedRationCard) {
    this._data.rationCard = selectedRationCard.value;
  }

  saveVoterData(voterForm) {
    if (this.visitorId === undefined) {
      if (!voterForm.valid) {
      } else {
        if (this.selectedRationCard != undefined) {
          this._data.rationCard = this.selectedRationCard["value"];
        } else {
          this._data.rationCard = null;
        }

        if (this.locationBinderObj.cityType != undefined) {
          this.locationBinderObj.cityType = this.locationBinderObj.cityType[
            "value"
          ];
        } else {
          this.locationBinderObj.cityType = null;
        }
        // if (this.editableMode) {
        //   this._data = Object.assign(this._data, this.locationBinderObj);
        //   this.genericService
        //     .updateGenericVisitor(this._data)
        //     .subscribe((res) => {
        //       this.dynamicContinue.emit({ isAdd: true });
        //       this.toast.add({
        //         severity: "success",
        //         summary: "Editable Successfully",
        //         detail: "Visitor Edited Successfully !!!",
        //       });
        //     });
        // } else {
        this._data = Object.assign(this._data, this.locationBinderObj);
        if (this.message != "EC009") {
          this.genericService.addGenericVisitor(this._data).subscribe((res) => {
            this.dynamicContinue.emit({ isAdd: true });
            this.toast.add({
              severity: "success",
              summary: "Created Successfully",
              detail: "Visitor Created Successfully !!!",
            });
            this.genericService.sendDynamicData(res);
          });
        }
        // }
      }
    } else if (this.visitorId !== undefined) {
      this._data = Object.assign(this._data, this.locationBinderObj);
      this.genericService.updateGenericVisitor(this._data).subscribe((res) => {
        this.dynamicContinue.emit({ isAdd: true });
        this.toast.add({
          severity: "success",
          summary: "Editable Successfully",
          detail: "Visitor Edited Successfully !!!",
        });
      });
      this.dynamicContinue.emit({ isAdd: true });
      this.toast.add({
        severity: "success",
        summary: "Added Successfully",
        detail: "Visitor Added Successfully !!!",
      });
      this.genericService.sendDynamicData(this._data);
    } else {
      this.dynamicContinue.emit({ isAdd: true });
      this.toast.add({
        severity: "success",
        summary: "Added Successfully",
        detail: "Visitor Added Successfully !!!",
      });
      this.genericService.sendDynamicData(this._data);
    }
  }
  onCancel() {
    this.dynamicContinue.emit({ isAdd: false });
  }

  saveProfile() {
    if (this.uploadedFiles.length >= 0) {
      this.imageUpload.upload();
    }
  }
  onUploadSuccess($event) {
    let imgFiles = $event.originalEvent.body.files;
    if (!this.editableMode) {
      this._data.ProfileImage = JSON.stringify(imgFiles);
    } else if (this.editableMode) {
      if (imgFiles && imgFiles.length != 0) {
        this._data.ProfileImage = JSON.stringify(imgFiles);
      } else {
        if (this.photo && this.photo != undefined) {
          this._data.ProfileImage = JSON.stringify(this.photo);
        } else {
          this._data.ProfileImage = JSON.stringify(imgFiles);
        }
      }
    }
    if (this._data.ProfileImage) {
      if (
        this._data.ProfileImage.length != 0 &&
        this._data.ProfileImage != "[]"
      ) {
        this.photo = JSON.parse(this._data.ProfileImage);
        this.profilePhoto = this.photo[0].filename;

        this.previewImg =
          this.apiBaseUrl +
          "/file-uploader/downloadS3?path=" +
          this.profilePhoto;
      }
    }
  }

  onUploadError($event) {
    this.profileError = true;
  }

  ngOnInit() {
    this.getDataFromVisitorList();
    this.getCast();
    this.editableNumber = this._data.phone;
    this.spinner.hide();
    this.officeId = this.sessionService.getOffice();
    this.userRole = this.sessionService.getUserInfo().role;
    let vv = this.sessionService.isVirtualView();
    if (this.userRole == "VIEWER" || vv) {
      this.netaFlag = true;
    }
  }
}
